import styled, { css } from 'styled-components';

export const UserInfo = styled.div`
  display: flex;
  column-gap: 68px;
  margin-top: 24px;
  margin-bottom: 48px;
`;

export const PicWrapper = styled.div`
  position: relative;
  border: 5px solid #0056ac;
  border-radius: 50%;
  width: 160px;
  height: 160px;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${(props) => props.theme.device.tablet} {
    width: 136px;
    height: 136px;
  }

  > span {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: ${(props) => props.theme.colors.themeColor};
    color: ${(props) => props.theme.colors.white};
    padding: 10px;
    border-radius: 50%;
  }
`;

export const InputFile = styled.input`
  display: none;
`;

export const InfoBlockContainer = styled.div`
  width: 100%;
  display: flex;
  column-gap: 68px;

  @media ${(props) => props.theme.device.tablet} {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  min-height: 200px;

  &:nth-child(3),
  &:nth-child(4) {
    border-left: 2px solid #d1d1d1;
    padding-left: 12px;
  }

  &:last-child {
    max-width: 284px;
  }
`;

export const InputContainer = styled.div`
  gap: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
  display: none;

  ${({ showInput }) =>
    showInput &&
    css`
      display: flex;
    `}
`;

export const InputWrapper = styled.div`
  width: 340px;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }
`;

export const FiltersWrapper = styled.div`
  margin: 32px 0 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;

  #filter-typology {
    order: 1;
  }

  #filter-categories {
    order: 2;
  }

  #filter-participation_years {
    order: 3;
  }

  #filter-published {
    order: 4;
  }

  #filter-time-interval {
    order: 5;
  }
`;

export const SortingWrapper = styled.div`
  margin-block: 24px;
  display: flex;
  align-items: baseline;

  > div:last-child {
    height: 48px;
  }
`;

const gridTableCol = css`
  --padding-inline: 24px;

  display: grid;
  grid-template-columns: 65px 2fr 1fr 1fr 1fr 1fr 90px 1fr 100px;
  column-gap: 24px;
  padding-inline: var(--padding-inline);
`;

export const Legend = styled.div`
  ${gridTableCol}
  margin-bottom: 24px;
  align-items: center;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }
`;

export const CardsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['hasPaginator'].includes(prop),
})`
  padding-bottom: ${({ hasPaginator }) => (hasPaginator ? 48 : 64)}px;

  > div:last-child {
    margin-bottom: 0;
  }
`;

export const CourseCard = styled.div`
  ${gridTableCol}
  align-items: center;
  margin-bottom: 16px;
  height: 100px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
`;

export const CompletionWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  svg {
    margin-top: -4px; //center to text
  }
`;

export const Column = styled.div.withConfig({
  shouldForwardProp: (prop) => !['rowGap'].includes(prop),
})`
  display: flex;
  flex-direction: column;
  row-gap: ${({ rowGap }) => rowGap}px;
`;

export const Type = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.darkerBlue};
  padding-left: 8px;
  line-height: 1;
`;
